import React from 'react';
import LegalPage from './LegalPage';
import { termsAndConditions } from '../00-shared/constants';

const TermsPage: React.FC = () => <LegalPage document={termsAndConditions} />;

export default TermsPage;
